export default function DeleteIcon(
  props: Pick<
    React.SVGProps<SVGSVGElement>,
    "className" | "fill" | "fillOpacity"
  >,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={props.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33203 4.16667C2.87179 4.16667 2.4987 4.53976 2.4987 5V15C2.4987 15.4602 2.87179 15.8333 3.33203 15.8333H10.832C11.2923 15.8333 11.6654 16.2064 11.6654 16.6667C11.6654 17.1269 11.2923 17.5 10.832 17.5H3.33203C1.95132 17.5 0.832031 16.3807 0.832031 15V5C0.832031 3.61929 1.95132 2.5 3.33203 2.5H7.88604C8.4433 2.5 8.96368 2.7785 9.27279 3.24217L10.4447 5H16.6654C18.0461 5 19.1654 6.11929 19.1654 7.5V10C19.1654 10.4602 18.7923 10.8333 18.332 10.8333C17.8718 10.8333 17.4987 10.4602 17.4987 10V7.5C17.4987 7.03976 17.1256 6.66667 16.6654 6.66667H10.4447C9.88743 6.66667 9.36704 6.38817 9.05793 5.9245L7.88604 4.16667H3.33203ZM18.5046 13.1607C18.8301 13.4862 18.8301 14.0138 18.5046 14.3393L17.0105 15.8333L18.5046 17.3274C18.8301 17.6528 18.8301 18.1805 18.5046 18.5059C18.1792 18.8314 17.6515 18.8314 17.3261 18.5059L15.832 17.0118L14.338 18.5059C14.0125 18.8314 13.4849 18.8314 13.1594 18.5059C12.834 18.1805 12.834 17.6528 13.1594 17.3274L14.6535 15.8333L13.1594 14.3393C12.834 14.0138 12.834 13.4862 13.1594 13.1607C13.4849 12.8353 14.0125 12.8353 14.338 13.1607L15.832 14.6548L17.3261 13.1607C17.6515 12.8353 18.1792 12.8353 18.5046 13.1607Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || 0.6}
      />
    </svg>
  );
}
